import React from 'react'

const DigitalTransformationContext = React.createContext({})

DigitalTransformationContext.displayName = 'DigitalTransformationContext'

export const DigitalTransformationProvider =
  DigitalTransformationContext.Provider
export const DigitalTransformationConsumer =
  DigitalTransformationContext.Consumer

export default DigitalTransformationContext
